/* mayie-hub-index: filtrele pe etichete din lista ghidurilor (sections/mayie-hub-index.liquid, setarea show_filters).
   „Toate” = cardurile din setarea max_guides; o etichetă = toate ghidurile cu eticheta aleasă, și cele ascunse. */
(function () {
  document.querySelectorAll('[data-mayie-guides]').forEach(function (root) {
    if (root.dataset.mayieGuidesReady) return;
    root.dataset.mayieGuidesReady = 'true';
    var chips = root.querySelectorAll('[data-filter]');
    var cards = root.querySelectorAll('[data-guide]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-filter');
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        root.classList.toggle('is-filtered', filter !== '');
        cards.forEach(function (card) {
          card.hidden = filter !== '' && card.getAttribute('data-tag') !== filter;
        });
      });
    });
  });
})();
